module.exports = __webpack_public_path__ + "static/media/logo-color.ada9d23c.svg";